module.exports = __webpack_public_path__ + "static/08-6ee43ef82f29cc4438179c76e63192ed.jpg";